import { useTranslation } from "react-i18next";

import { Button } from "@/shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/components/ui/dialog";

import type { JobWebhookHandoff } from "../types/job";
import { CopyField } from "./CopyField";

interface WebhookHandoffDialogProps {
  handoff: JobWebhookHandoff | null;
  onClose: () => void;
}

/**
 * Depois de salvar um job de webhook (AB#86605): o que repassar a quem vai
 * chamar — endereço e credencial. Tudo pode ser lido de novo na edição do job.
 */
export function WebhookHandoffDialog({ handoff, onClose }: WebhookHandoffDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={Boolean(handoff)} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("jobs.webhook.handoffTitle")}</DialogTitle>
          <DialogDescription>{t("jobs.webhook.handoffDescription")}</DialogDescription>
        </DialogHeader>
        {handoff && (
          <div className="space-y-3">
            <CopyField label={t("jobs.webhook.url")} value={handoff.url} />
            <p className="text-xs text-muted-foreground">
              {t(handoff.auth_type === "basic" ? "jobs.webhook.basicHint" : "jobs.webhook.bearerHint")}
            </p>
            {handoff.auth_type === "basic" && handoff.username && (
              <CopyField label={t("jobs.webhook.username")} value={handoff.username} />
            )}
            {handoff.secret && (
              <CopyField
                label={t(handoff.auth_type === "basic" ? "jobs.webhook.password" : "jobs.webhook.token")}
                value={handoff.secret}
                secret
              />
            )}
          </div>
        )}
        <DialogFooter>
          <Button onClick={onClose}>{t("jobs.webhook.done")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
